import { render } from 'preact';

import { AppRouter } from './AppRouter.tsx';

render(<AppRouter />, document.getElementById('app')!);
